




import { Component, Prop, Vue } from 'vue-property-decorator';
import RequestsTable from '@/components/Requests/RequestsTable.vue';

@Component({
  components: {
    RequestsTable,
  },
})
export default class MyRequests extends Vue {

}
